var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgParameters = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67596 8.79958C6.88059 9.3677 5.90216 9.70857 4.85429 9.70857C2.1778 9.70857 0 7.52446 0 4.85429C0 2.18411 2.1778 0 4.85429 0C7.52446 0 9.70857 2.18411 9.70857 4.85429C9.70857 5.95897 9.33614 6.97528 8.7112 7.7959L11.6844 10.7754C11.8232 10.9143 11.8864 11.091 11.8864 11.2804C11.8864 11.6844 11.5897 12 11.1794 12C10.99 12 10.8069 11.9306 10.6681 11.7917L7.67596 8.79958ZM5.34375 8.6287V3C5.34375 2.74112 5.13388 2.53125 4.875 2.53125C4.61612 2.53125 4.40625 2.74112 4.40625 3V8.63405C4.0797 8.59498 3.76533 8.51381 3.46875 8.39622V6C3.46875 5.74112 3.25888 5.53125 3 5.53125C2.74112 5.53125 2.53125 5.74112 2.53125 6V7.85985C1.63105 7.16014 1.04787 6.06832 1.04787 4.85429C1.04787 2.77117 2.76486 1.04787 4.85429 1.04787C6.9374 1.04787 8.6607 2.77117 8.6607 4.85429C8.6607 6.04838 8.09445 7.12425 7.21875 7.82507V4.5C7.21875 4.24112 7.00888 4.03125 6.75 4.03125C6.49112 4.03125 6.28125 4.24112 6.28125 4.5V8.37843C5.98489 8.50035 5.67046 8.5857 5.34375 8.6287Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgParameters);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Parameters.61772364524d6a5ab4e87e9f71a97ac6.svg";